import {Injectable} from '@angular/core';
import {HttpHelper} from '../../http-helper';
import {Observable} from 'rxjs';
import {PrioritiesResponse} from '../models/priority.model';

@Injectable({providedIn: 'root'})
export class PriorityService {

  constructor(private httpHelper: HttpHelper) {
  }

  getPriorities(): Observable<PrioritiesResponse> {
    return this.httpHelper.getRequest("/jira/priorities")
  }
}
